import { render, staticRenderFns } from "./ModalEditTipePelunasan.vue?vue&type=template&id=1b4233f4&"
import script from "./ModalEditTipePelunasan.vue?vue&type=script&lang=js&"
export * from "./ModalEditTipePelunasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports